import { useState } from "react";
import { SocialIcon } from "components/UI/SocialIcon";
import { updateInputData } from "./SocialLinksForm";
import "./styles/SocialLinkItem.scss";

interface ISocialLinkItemProps {
  value: string;
  id: string;
  name: string;
  validMessage: null | string;
  updateInput: (id: string, inputToUpdateValues: updateInputData) => void;
  removeInput: (id: string, name: string) => void;
  placeholder?: string;
}

export const SocialLinkItem = (props: ISocialLinkItemProps) => {
  const {
    value,
    id,
    name,
    validMessage,
    updateInput,
    removeInput,
    placeholder,
  } = props;
  const [iconType, setIconType] = useState<string | null>(name);

  const handleRemove = () => {
    removeInput(id, name);
  };

  const handleUpdate = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const validMessage = !value.length ? "Please complete your profile url" : null;
    const dataToUpdate = { value, validMessage };

    setIconType(name);
    updateInput(id, dataToUpdate);
  };

  const renderError = () => {
    if (!validMessage) {
      return null;
    }

    return (
      <div className="SocialLinkItem-Error">
        {validMessage}
      </div>
    );
  };

  return (
    <div className="SocialLinkItem">
      <div className="SocialLinkItem-InputWrap">
        <div className="SocialLinkItem-IconWrap">
          {iconType && <SocialIcon name={iconType} />}
        </div>
        <div className="SocialLinkItem-Input">
          <span>{placeholder}</span>
          <input
            id={id}
            onChange={handleUpdate}
            value={value}
            name={name}
            type="text"
            placeholder="your-profile"
          />
        </div>
        <button type="button" className="SocialLinkItem-Remove" onClick={handleRemove}>
          <span></span>
        </button>
      </div>
      {renderError()}
    </div>
  );
};
